export const SMALL_BREAKPOINT = 576
